export default "__VITE_ASSET__LmuYfuK4__"